import GtrSuper from '@/modules/common/components/mixins/gtr-super.mixin'
import { Component } from 'vue-property-decorator'

@Component({
  name: 'GtrCall4PapersView'
})
export default class GtrCall4PapersView extends GtrSuper {
}
